/**
 * Validate a post-login return URL.
 *
 * Only same-origin paths are allowed: the value must start with a single `/`.
 * Protocol-relative URLs (`//evil.com`) and backslash escapes (`/\evil.com`,
 * which browsers treat as `//`) are rejected to prevent open redirects.
 */
export const getSafeReturnUrl = (url: string | null | undefined): string | undefined => {
  if (!url || url === '0' || url === 'undefined') return undefined
  if (!url.startsWith('/') || url.startsWith('//') || url.startsWith('/\\')) return undefined
  return url
}
